/**
 * @generated SignedSource<<29af87062fbf008ecca63d1f4d9edee1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type outerObjectContext_MarkRelatedNotificationsAsReadMutation$variables = {
  outerObjectIds: ReadonlyArray<string>;
};
export type outerObjectContext_MarkRelatedNotificationsAsReadMutation$data = {
  readonly NotificationCenter_MarkRelatedAsRead: {
    readonly changedNotifications: ReadonlyArray<{
      readonly id: string;
      readonly unread: boolean;
    }>;
    readonly notificationCenter: {
      readonly id: string;
      readonly unreadNotificationCount: number;
    };
  } | null;
};
export type outerObjectContext_MarkRelatedNotificationsAsReadMutation = {
  response: outerObjectContext_MarkRelatedNotificationsAsReadMutation$data;
  variables: outerObjectContext_MarkRelatedNotificationsAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "outerObjectIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "outerObjectIds",
        "variableName": "outerObjectIds"
      }
    ],
    "concreteType": "MarkRelatedNotificationsAsRead",
    "kind": "LinkedField",
    "name": "NotificationCenter_MarkRelatedAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationCenterEntry",
        "kind": "LinkedField",
        "name": "changedNotifications",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unread",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationCenter",
        "kind": "LinkedField",
        "name": "notificationCenter",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unreadNotificationCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "outerObjectContext_MarkRelatedNotificationsAsReadMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "outerObjectContext_MarkRelatedNotificationsAsReadMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "73ec907c83d1ce701ab431c4cd383fb7",
    "id": null,
    "metadata": {},
    "name": "outerObjectContext_MarkRelatedNotificationsAsReadMutation",
    "operationKind": "mutation",
    "text": "mutation outerObjectContext_MarkRelatedNotificationsAsReadMutation(\n  $outerObjectIds: [ID!]!\n) {\n  NotificationCenter_MarkRelatedAsRead(outerObjectIds: $outerObjectIds) {\n    changedNotifications {\n      id\n      unread\n    }\n    notificationCenter {\n      id\n      unreadNotificationCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bdf8a09756e781858a788170dfbdb03";

export default node;
